import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import close_modal from "../../../assets/ic_close_wh.svg";

export default function SendNeftDetails(props) {
	return (
		<div>
			<Modal
				isOpen={props.isOpen}
				onRequestClose={() => props.toggleModal(!props.isOpen)}
				ariaHideApp={false}
			>
				<ModalContent className="medium-general-modal conv-width-40%">
					<div className="modal-header">
						<span className="modal-title">Send NEFT Detail</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={() => props.toggleModal(!props.isOpen)}
						/>
					</div>
					<div className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar`}>
						<div className="row">
							<div className="col-12">
								{props.neftPaymentDetails["bank_details"] && (
									<div className="conv-mt10">
										<div>
											Account Holder Name :{" "}
											{props.neftPaymentDetails["bank_details"] &&
												props.neftPaymentDetails["bank_details"][
													"AccountHolderName"
												]}
										</div>
										<div>
											Account Number :{" "}
											{props.neftPaymentDetails["bank_details"] &&
												props.neftPaymentDetails["bank_details"][
													"AccountNumber"
												]}
										</div>
										<div>
											IFSC Code :{" "}
											{props.neftPaymentDetails["bank_details"] &&
												props.neftPaymentDetails["bank_details"][
													"IFSCCode"
												]}
										</div>
										<div>
											Branch :{" "}
											{props.neftPaymentDetails["bank_details"] &&
												props.neftPaymentDetails["bank_details"][
													"BranchName"
												]}
										</div>
										<br />
										<button 
											type="button" 
											className={`my-services-model-submit-btn conv-pl25 conv-pr25 conv-mt10`}
											onClick={() =>props.onClickSendNeftAccountDetails()}>
											Send
										</button>
									</div>
								)}								
							</div>
						</div>
					</div>
					
				</ModalContent>
			</Modal>
		</div>
	);
}
